/**
 * New Zealand states (is the country).
 */
export enum NewZealandState {
  NewZealand = 'New Zealand',
}
